import toast from '@utils/toast'

export default function _api ({ url, method = 'GET', data }) {
  const param = {
    method,
    headers: {
      'content-type': 'application/json;charset=UTF-8'
    }
  }
  if (method.toLowerCase() === 'post') param.body = JSON.stringify(data)
  return fetch(url, param)
    .then(res => res.json())
    .then(res => {
      if (+res.code === 0) {
        return res.data
      } else {
        if (res.message) toast(res.message)
        throw new Error(res)
      }
    })
    .catch(err => {
      throw new Error(err)
    })
}
